module.exports = __webpack_public_path__ + "img/people-dark.b7754c9a.svg";